import { useState, useEffect } from "react";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import PopUp from "../PopUp";

const Mansioni = () => {
  const [loading, setLoading] = useState(false);
  const [mansioni, setMansioni] = useState([]);
  const navigate = useNavigate();
  const [perPage] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedMansioneId, setSelectedMansioneId] = useState(null);

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per visualizzare le mansioni!");

      navigate("/login");
      localStorage.clear();
    } else {
      fetchMansioni();
    }
  }, []);

  const fetchMansioni = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/mansioni`);
      if (response.status === 200) {
        setMansioni(response.data);
        setTotalRows(response.data.length);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (mansioni) => {
    navigate(`/mansioni/${mansioni.idMansione}`, {
      state: { mansioni },
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedMansioni = mansioni.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const columns = [
    { field: "nomeMansione", header: "Mansione", size: 350 },
    { field: "descrizioneMansione", header: "Descrizione", size: 400 },

    {
      header: "Azioni",
      Cell: ({ row }) => (
        <button
          className="outside-delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedMansioneId(row.original.idMansione);
            setShowPopUp(true);
          }}
        >
          <i className="fa-solid fa-trash"></i> Elimina
        </button>
      ),
    },
  ];

  const handleDelete = async () => {
    if (!selectedMansioneId) {
      return;
    }
    try {
      const response = await api.delete(`/mansioni/${selectedMansioneId}`);
      if (response.status === 204) {
        toast.success("Mansione eliminata con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        fetchMansioni();
      }
    } catch (error) {
      if (error.response?.data?.message?.includes("REFERENCE constraint")) {
        toast.error(error?.response?.data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } else {
        toast.error("Errore durante l'eliminazione della mansione.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } finally {
      setShowPopUp(false);
      setSelectedMansioneId(null);
    }
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <PopUp
        open={showPopUp}
        setOpen={setShowPopUp}
        header="Conferma Eliminazione"
        content="Sei sicuro di voler eliminare questo elemento?"
        deleteFunction={handleDelete}
      />

      <div className="page-header">
        <div className="page-title">Mansioni</div>
        <div className="controls">
          <div className="add-btn">
            <button onClick={() => navigate("/aggiungi-mansione")}>
              + Nuovo mansione
            </button>
          </div>
        </div>
      </div>

      <div className="page-content mansioni">
        <Table
          columns={columns}
          data={paginatedMansioni}
          onRowClick={handleRowClick}
          onPageChange={handlePageChange}
          totalRows={totalRows}
          perPage={perPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default Mansioni;
